<template>
  <div class="row" v-if="can_access('customer','view')">
    <div class="col-md-12 form-group mb-0" style="display: block ruby;">
		  <h1 class="">Client Reports</h1>
      <!-- <b-form-select v-model="sheet" style="color:#000;font-weight:600" :options="options" class="col-md-2 pull-right mt-1"></b-form-select> -->
      <!-- <div class="form-inline pull-right">
          <div class="form-group">    
              <date-picker input-class="form-control" :disabled-date="disabledDates" ref="report_date" value-type="format" type="date" v-model="report_date" format='DD-MM-YYYY'></date-picker>
          </div>
      </div> -->
    </div>
    <!-- <div class="row col-md-12 mb-2 pr-0">
      <div class="col-md-4 form-group">
      </div>
      <div class="col-md-2 form-group">
      </div>
      <div class="col-md-6 pr-0">
        <a class="pull-right" href="javascript:;" @click="get_report_modal" title="Download IRESS reports for all accounts" v-if="can_access('report','download')"><i class="fa fa-archive" aria-hidden="true"></i> Download IRESS Reports</a>&nbsp;
        <a class="pull-right mr-2" target="_blank" ref="download" href="javascript:;" @click.prevent="download"><i class="fa fa-file"></i> Generate IRESS Reports for {{report_date}}</a>
      </div>
    </div> -->
    
    <div class="col-md-12">
      <TableView :col="columns" :getData="getData" v-if="can_access('customer','view') && !sheet"/>
      <!-- <MISDailyStatusReport v-else-if="sheet==1 && can_access('report','view')"/> -->

      <b-modal ref="get-report-out" title="Download Reports" size="xl" hide-footer>
        <ReportsInExcel :file_prefix="filenameprefix"/>
      </b-modal>      
    </div>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import common from '@/assets/js/common.js';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import AddCustomerForm from '@/components/Accounts/AddCustomerForm';
import TableView from '@/components/Common/DataTable/Table';
import ReportsInExcel from '@/components/Accounts/ReportsInExcel.vue';
//import MISDailyStatusReport from '@/components/Accounts/MISDailyStatusReport.vue';

export default {
  name: 'CustomersPage',
  components: { Widget, AddCustomerForm, TableView, ReportsInExcel, DatePicker },
  mixins: [common],
  data() {
    return {
      sheet: '',
      filenameprefix:'iress\\/all\\/',
      /* options: [
        { value: '', text: 'BASIC REPORT' },
        { value: '1', text: 'MIS DAILY STATUS' },
      ], */
      showAddCustomerForm: false,
      errorMessage: null,
      report_date: moment().format('DD-MM-YYYY'),
      columns: (() => {
        const cols = [
          { title: 'Accoun No.', field: 'account_number', label: 'User ID', thComp: 'FilterTh', sortable: true, visible: 'true' },
          { title: 'Title', field: 'title', thComp: 'FilterTh' },
          { title: 'Firstname', field: 'firstname', thComp: 'FilterTh', tdStyle: { fontStyle: 'italic' } },
          { title: 'Lastname', field: 'lastname', thComp: 'FilterTh', thStyle: { fontWeight: 'normal' } },
          { title: 'Email', field: 'email', thComp: 'FilterTh', tdComp: 'Email'},
          { title: 'Phone', field: 'phone_no', thComp: 'FilterTh'},
          { title: 'DOB/Incorporation Date', field: 'dob', sortable: true },
          { title: 'Operation', tdComp: 'reportOpt', visible: 'true', tdStyle:{'text-align':'center'}, thStyle:{'text-align':'center'} }
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          if(!this.can_view_field('customer', col.nested?col.nested:col.field) && col.title != 'Operation') col.visible = false;
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
    };
  },
  methods: {
    customerFormReRender(response) {
      if(response.code==0){
        this.showAddCustomerForm = false;
        this.$nextTick(function(){
          this.showAddCustomerForm = true;
          this.$toasted.success("Successfully Added",{duration:1000});
        });
      }
    },
    async getData(query, filter) {
      var { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
      //filter['has_trade'] = 1;
      filter['approved_at'] = {from_date:'2020-01-01'};
      this.columns.forEach(col => {
        if (query[col.field]) {
          filter[col.field] = query[col.field];
        }else if(typeof filter[col.field] != 'undefined'){
          delete filter[col.field];
        }
      });

      let uri = 'customer_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      return await this.call_axios(uri);
    },
    disabledDates(date){
      if(moment(date).isAfter(moment())) return true;
      return false;
    },
    download() {
      let uri = 'generate_iress_report?account_number=all&report_date='+this.report_date+'&base_cur=USD';
      this.call_axios(uri).then(res => this.$toasted.success(res.response.result, {duration:2500}));
    },
    get_report_modal(){
      this.$refs['get-report-out'].show();
    },
  },
  created() {
    
  },
};
</script>